import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button.tsx';

type PlantsFiltersToggleProps = {
  open: boolean;
  onToggle: () => void;
};

export const PlantsFiltersToggle = ({ open, onToggle }: PlantsFiltersToggleProps) => {
  return (
    <Button
      title={open ? 'Hide filters' : 'Show filters'}
      variant="ghost"
      size="sm"
      onClick={onToggle}
      className={`flex size-9 min-w-9 rounded-md border border-gray-200 bg-white p-0 sm:hidden ${
        open ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
    </Button>
  );
};
